export const modals = {
  confirm_lock_conference: {
    title: 'Lock Conference',
    description: 'Locking a conference will prevent new participants from joining. You can only lock conference when you are in it.'
  },
  confirm_mute_all: {
    title: 'Mute Everyone',
    description: 'Everyone will be notified that they have been muted. Callers can un-mute themselves by tapping Un-mute button. You can un-mute participants individually at any time.'
  },
  confirm_muted_by_admin: {
    title: 'You were muted by admin',
    description: 'You can un-mute yourself by tapping Un-mute button.'
  },
  prompt_conference_ended: {
    title: 'Conference ended',
    description: 'You have been disconnected from a call.'
  },
  prompt_conference_kicked: {
    title: 'You were kicked by admin',
    description: 'You can always re-join to conference.'
  },
  prompt_join_error_incorrect_credentials: {
    title: 'Incorrect ID or PIN',
    description: 'You can’t join this conference because ID or PIN is incorrect. Please contact an administrator.'
  },
  prompt_join_error_room_locked: {
    title: 'Conference is locked',
    description: 'You can’t join this conference because it has been locked. Please contact an administrator.'
  },
  prompt_join_error_room_full: {
    title: 'Conference is full',
    description: 'You can’t join this conference because it has reached its maximum capacity. Please contact an administrator.'
  },
  prompt_join_error_unknown: {
    title: 'Ops!',
    description: 'Unknown error'
  }
};



// WEBPACK FOOTER //
// ./src/constants/modals.constant.js